import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { ModalProps } from '../../../types/modal';
import React from 'react';
import { User } from '../../../types/user';
import { useEditCompanyMutation } from '../../../../app/Slices/SevenDayApiSlice';
import UserRole from '../../../../shared/AuthRoles';
import toast from '../../../shared/Toast';

interface DeleteModalProps extends ModalProps {
    user: User;
    messagingUsers: User[];
}

const DeleteModal = ({
    open,
    onClose,
    user,
    messagingUsers,
}: DeleteModalProps) => {
    const loggedInUser = UserRole();

    const URL = `/owners/${loggedInUser?.company}`;
    const [updateCompany] = useEditCompanyMutation();

    const handleDelete = async () => {
        try {
            const request = {
                messagingUsers: messagingUsers.filter(
                    (mu) => mu.id !== user.id,
                ),
            };

            await updateCompany([URL, request]).unwrap();
            toast.success('User deleted successfully');
            onClose();
        } catch (error) {
            toast.error('Error removing user');
        }
    };
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>
                Remove User
                <IconButton
                    onClick={onClose}
                    sx={{ color: 'text.primary' }}
                    aria-label='close'
                >
                    <Close />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                <Typography>
                    Are you sure you want to remove {user.firstName}{' '}
                    {user.lastName}? This action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='contained'
                    color='error'
                    onClick={handleDelete}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeleteModal;
